// frontend/src/components/Auth/LoginPage.js
import React, { useState } from 'react'; // Make sure useState is imported
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';

const LoginPage = () => {
    const [username, setUsername] = useState(''); // Used by input
    const [password, setPassword] = useState(''); // Used by input
    const [message, setMessage] = useState('');   // Used to display error messages
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setMessage(''); // Reset message on new attempt
        try {
            const response = await authService.login(username, password);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('token', response.data.token);
            navigate('/home');
            window.location.reload(); // To update navbar and other components relying on auth state
        } catch (error) {
            const resMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            setMessage(resMessage); // Set the error message to be displayed
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card">
                        <div className="card-header">Login</div>
                        <div className="card-body">
                            <form onSubmit={handleLogin}>
                                <div className="form-group">
                                    <label htmlFor="username">Username</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="username"
                                        value={username} // Read username state
                                        onChange={(e) => setUsername(e.target.value)} // Update username state
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="password">Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="password"
                                        value={password} // Read password state
                                        onChange={(e) => setPassword(e.target.value)} // Update password state
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary btn-block">
                                    Login
                                </button>
                                {/* Display the message if it's set */}
                                {message && (
                                    <div className="alert alert-danger mt-3" role="alert">
                                        {message}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;